import React, { Component } from 'react';
import Loading from "./../../elements/loading";
import RevisionReportsLayout from "../../templates/revision_reports";
import ReportsSummaryEditForm from '../../elements/revision/reports_summary';

class RevisionReportsSummary extends Component{
	render (){
		let { revision } = this.props;
		return (
			revision.isFetching ? <Loading/>:<ReportsSummaryEditForm {...this.props}/>
		)
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;
		this.props.reset('reports');
		this.props.fetchRevisionReports('project-report-summary',modality, state, municipality);
	}

	componentWillReceiveProps(newprops) {
		let { modality, state, municipality } = newprops.match.params;

		if(newprops.match.params !== this.props.match.params) {
			this.props.fetchRevisionReports('project-report-summary',modality, state, municipality);
		}
	}
}

export default RevisionReportsLayout(RevisionReportsSummary, {subnav: 3});


// WEBPACK FOOTER //
// ./src/layouts/revision/reports_summary.jsx